// packages/web-ui/src/AppShell/StatusBar.tsx
//
// W2-S2 AC #1 — 22 px tall full-width footer of `<TabContentArea>`.
// W3 fix-pass HIGH-7 — capability pills + workspace context wired through
// `useCapabilities`. The status-bar mirrors the banner's pill row at the
// bottom of the shell so the same signal is reachable without scrolling
// past chat history. Session id and detailed health-summary copy land in
// W4-S6 (out-of-scope for this fix-pass).

import type { JSX } from 'react';
import { PANEL_DEFAULT_WIDTHS, Z_INDEX } from './responsive-tokens.js';
import { CapabilityPillRow } from '../components/capability-pills/index.js';
import { useCapabilities } from '../hooks/useCapabilities.js';

export function StatusBar(): JSX.Element {
  const { capabilities, loading, error } = useCapabilities();
  return (
    <footer
      role="contentinfo"
      aria-label="Status"
      data-testid="status-bar"
      className="bg-cream-50 border-taupe-300 text-taupe-700 flex items-center justify-between border-t px-3 font-mono text-[10px] uppercase tracking-[0.06em]"
      style={{
        height: PANEL_DEFAULT_WIDTHS.statusBar,
        zIndex: Z_INDEX.statusBar,
      }}
    >
      <CapabilityPillRow
        capabilities={capabilities}
        loading={loading}
        error={error}
        testId="status-bar-pills"
      />
      <span data-testid="status-bar-workspace" className="truncate">
        {capabilities?.workspaceRoot ?? ''}
      </span>
    </footer>
  );
}
